import Translator from '../../classes/Translator/Translator';
const MarketLogic = () => {
    const { translator } = Translator();

    return {
        translator,
    };
};
export default MarketLogic;
